export const environment = {
  production: true,
  // apiUrl: 'http://localhost:8080/isandata/Project/BackEnd/'
  // apiUrl: 'https://isandatasystem.000webhostapp.com/api/'
  apiUrl: 'https://isandatasystems.com/api/'
};
